import React from 'react';

function SocialIcon(props) {
    const {link, icon, label} = props;
    const isResume = label === 'resume';

    return (
        <a target="_blank"
           rel="noopener noreferrer"
           href={link}
           download={isResume ? "AlexPedrasa_Resume.pdf" : undefined}>
            <i className={icon} aria-hidden="true"/>
        </a>
    );
}

export default SocialIcon;